import {
	CALENDAR_CONNECTOR_TYPES,
	type CalendarConnectorType,
	type ConnectedDataSource,
} from '../types';

export type { CalendarConnectorType };

export const fetchEnabledConnectorTypes = async (
	cloudId: string,
): Promise<CalendarConnectorType[]> => {
	const response = await fetch(
		`/gateway/api/third-party-configuration/connected-data-sources/${cloudId}`,
		{
			method: 'GET',
			headers: {
				'X-Cloudid': cloudId,
			},
		},
	);

	if (!response.ok) {
		throw new Error(`Failed to fetch calendar connectors (${response.status})`);
	}

	const connectors = (await response.json()) as ConnectedDataSource[];
	const enabled = new Set(connectors.map((connector) => connector.type));

	return CALENDAR_CONNECTOR_TYPES.filter((type) => enabled.has(type));
};
